import React, { useState, useMemo } from 'react';
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Form, Button } from "antd";
import { CreateCheckbox, CreateFileField } from "../Helpers/Input/InputCreator";
import { required } from "../Helpers/Input/validations";
import importCertificateNetcoCodes from '../../actions/certificates/importCertificateNetcoCodes';
import PrivateRoute from "../Root/PrivateRoute";
import certificates from "../../const/certificates";
import { ReactComponent as OtherCertificatesIcon } from '../../resources/img/NewIcons/certificates/other-certificates.svg'
import { INFO_SHOW } from "../../actions/types";
import infoPayload from "../../actions/helpers/payloadHandlers/infoPayload";

const ZIPOption = (props) => {

    const [formFile, setFormFile] = useState([])

    const onSubmit = (formValues) => {
        let file = formFile[0] === undefined ? null : formFile[0].file;
        formValues.language = props.language;
        formValues.requiresCert = props.requiresCert;
        props.importCertificateFromZIP(formValues, file);
    };

    const handleOnDropFile = (newFile) => {
        if (!newFile || newFile.length <= 0) {
            props.dispatch({ type: INFO_SHOW, payload: infoPayload('error', certificates[props.language].invalidFile) });
            return;
        }
        const formFileDrop = {
            file: newFile[0],
            name: newFile[0].name,
            preview: URL.createObjectURL(newFile[0]),
            size: newFile[0].size
        };
        props.change('avatar', formFileDrop);
        setFormFile([formFileDrop])
    };
    const requiredLanguage = useMemo(() => required(props.language), [props.language]);
    return (
        <>
            {props.renderCardCertificates(certificates[props.language].zipTitle, certificates[props.language].zip_info, OtherCertificatesIcon, certificates[props.language].zip_info2)}
            <Form onFinish={props.handleSubmit(onSubmit)} className={'text-title size12 mt-20'} style={{ marginLeft: 14 }}>
                <div className={'mb-10 mt-10'}>{certificates[props.language].zip_file}</div>
                <Field
                    name="avatar"
                    component={CreateFileField}
                    handleOnDrop={handleOnDropFile}
                    type='file'
                    formFile={formFile}
                    validate={requiredLanguage}
                    multiple={false}
                    language={props.language}
                />
                <Field name="updateGraphicImage"
                    className='mt-20'
                    type={'checkbox'}
                    component={CreateCheckbox}
                    hasFeedback>
                    {certificates[props.language].graphic_image}
                </Field>
                <Button htmlType={'submit'} className='mt-20' type={'primary'} style={{ marginRight: 21 }}>
                    {certificates[props.language].createZIP}
                </Button>
                <Button type={'ghost'} onClick={() => props.changeOption(0)}>
                    {certificates[props.language].cancel}
                </Button>
            </Form>
        </>

    );
};

const mapStateToProps = state => {
    return {
        language: state.auth.language,
        requiresCert: state.auth.requiresCert,
        initialValues: {
            agree: false,
            updateGraphicImage: false
        }
    }
};

export default PrivateRoute(connect(mapStateToProps, { importCertificateNetcoCodes })((reduxForm({
    form: 'netcoCertificate_form'
})(ZIPOption))));

